import React from 'react';
import {
  BarChart,
  PieChart,
  Bar,
  Pie,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
  LineChart,
  Line
} from 'recharts';
import './NuevoDashboard.css';

const DashboardVentasHistoricas = ({ dataVentasPorMeses, dataSucursales, idSucursal, handleSucursalChangeHistoricas }) => {
    const tieneDatos = dataVentasPorMeses && Array.isArray(dataVentasPorMeses) && dataVentasPorMeses.length > 0;

    if (!tieneDatos) {
        return (
            <div className="dashboard-container">
                <div className='loading-state'>
                    <div className='spinner'></div>
                    <h3>Cargando Datos de Ventas...</h3>
                </div>
            </div>
        )
    }

    const salesDataHistoricas = dataVentasPorMeses.map(mes => ({
        mes: `${mes.Mes}`,
        total: parseFloat(mes.Total || 0),
        vales: parseFloat(mes.Vales || 0),
        compras: parseFloat(mes.Compras || 0)
    }));

    // Calcular totales
    const totalVentas = salesDataHistoricas.reduce((sum, item) => sum + item.total, 0);
    const totalVales = salesDataHistoricas.reduce((sum, item) => sum + item.vales, 0);
    const totalCompras = salesDataHistoricas.reduce((sum, item) => sum + item.compras, 0);
    const Balance = (totalVentas + totalVales - totalCompras).toFixed(2);

    // Colores para los gráficos
    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D'];

    // Datos para el gráfico circular (Pie)
    const pieData = [
        { name: 'Ventas Totales', value: totalVentas },
        { name: 'Vales', value: totalVales },
        { name: 'Compras', value: totalCompras }
    ];

    return (
        <div className="dashboard-container">
            <div style={{ 
                border: '1px solid #01a59c',
                backgroundColor: '#dbedec',
                padding: '15px', 
                borderRadius: '1.25rem', 
                marginBottom: '20px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
                <div className="row">
                    <div className="col-md-6 mb-2">
                        <label className="form-label"><strong>Sucursal:</strong></label>
                        <select
                        className="form-control"
                        name="sucursal"
                        value={idSucursal || ""}
                        onChange={handleSucursalChangeHistoricas}
                        >
                        <option value="">Sucursal actual</option>
                        {dataSucursales && dataSucursales.map(sucursal => (
                            <option
                            key={sucursal.IdSucursal}
                            value={sucursal.IdSucursal}
                            title={sucursal.Nombre}
                            >
                            {sucursal.Nombre}
                            </option>
                        ))}
                        </select>
                    </div>
                </div>
            </div>
            <h2 className="text-center">Dashboard de Ventas Históricas</h2>
            <div className="dashboard-header">
                <div className="header-stats">
                    <div className="stat-card primary">
                        <span className="stat-label">Total Ventas</span>
                        <span className="stat-value">S/ {totalVentas}</span>
                    </div>
                    <div className="stat-card secondary">
                        <span className="stat-label">Total Vales</span>
                        <span className="stat-value">S/ {totalVales}</span>
                    </div>
                    <div className="stat-card secondary">
                        <span className="stat-label">Total Compras</span>
                        <span className="stat-value">S/ {totalCompras}</span>
                    </div>
                    <div className={`stat-card ${Balance >= 0 ? 'success' : 'danger'}`}>
                        <span className="stat-label">Balance</span>
                        <span className="stat-value">S/ {Balance}</span>
                    </div>
                </div>
            </div>

            <div className='dashboard-content'>
                <div className='chart-row'>
                    <div className='chart-container'>
                        <h3>Evolución Mensual de Ventas</h3>
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart data={salesDataHistoricas}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="mes" />
                                <YAxis />
                                <Tooltip formatter={(value) => [`S/ ${value.toFixed(2)}`, 'Monto']} />
                                <Legend />
                                <Line type="monotone" dataKey="total" stroke="#8884d8" activeDot={{ r: 8 }} />
                                <Line type="monotone" dataKey="vales" stroke="#82ca9d" />
                                <Line type="monotone" dataKey="compras" stroke="#ff8042" />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </div>

                <div className='chart-row'>
                    <div className='chart-container half-width'>
                        <h3>Comparación Mensual</h3>
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={salesDataHistoricas}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="mes" />
                                <YAxis />
                                <Tooltip formatter={(value) => [`S/ ${value.toFixed(2)}`, 'Monto']} />
                                <Legend />
                                <Bar dataKey="total" fill="#8884d8" name="Ventas Totales" />
                                <Bar dataKey="vales" fill="#82ca9d" name="Vales" />
                                <Bar dataKey="compras" fill="#ff8042" name="Compras" />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </div>

                {/* <div className='chart-row'>
                    <div className='chart-container'>
                        <h3>Detalle por Mes</h3>
                        <div className="data-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Mes</th>
                                        <th>Ventas Totales</th>
                                        <th>Vales</th>
                                        <th>Compras</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {salesDataHistoricas.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.mes}</td>
                                            <td>S/ {item.total.toFixed(2)}</td>
                                            <td>S/ {item.vales.toFixed(2)}</td>
                                            <td>S/ {item.compras.toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div> */}
                <div className='weekly-breakdown'>
                    <h3 className='text-center'>Detalle por mes</h3>
                    <div className='weekly-cards'>
                        {salesDataHistoricas.map((item, index) => {
                            return (
                                <div key={index } className='week-card'>
                                    <h4>{item.mes}</h4>
                                    <p><strong>Ventas Totales:</strong> S/ {item.total.toFixed(2)}</p>
                                    <p><strong>Vales:</strong> S/ {item.vales.toFixed(2)}</p>
                                    <p><strong>Compras:</strong> S/ {item.compras.toFixed(2)}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>  
    );
}

export default DashboardVentasHistoricas;